<template>
    <article class="review-item" aria-label="匿名服务评价">
        <p class="review-author"><span class="anonymous-avatar" aria-hidden="true">匿</span>匿名用户</p>
        <p class="review-score" :aria-label="'评分 ' + review.score + ' 分，满分 5 分'">{{ review.score }} / 5</p>
        <p class="review-text">{{ review.displayText }}</p>
        <p class="review-time">{{ review.reviewedAt }}</p>
        <dl class="review-service" aria-label="下单时的服务背景">
            <div v-for="field in serviceFields" :key="field.key"><dt>{{ field.label }}</dt><dd>{{ (review.service || {})[field.key] || '未提供' }}</dd></div>
        </dl>
        <ServiceReviewImages v-if="review.images && review.images.length" :key="review.reviewId" :review-id="review.reviewId" :images="review.images" @refresh="$emit('refresh')" />
    </article>
</template>
<script>
import ServiceReviewImages from '@/components/photography/ServiceReviewImages.vue';
export default {
    name: 'ServiceReviewItem',
    components: { ServiceReviewImages },
    props: { review: { type: Object, required: true } },
    data: () => ({ serviceFields: [
        { key: 'themeTypeName', label: '主题类型' }, { key: 'themeName', label: '主题' },
        { key: 'styleName', label: '风格' }, { key: 'packageName', label: '套餐' }, { key: 'venueName', label: '场地' },
    ] }),
};
</script>
<style scoped>
.review-item { min-width:0; padding:20px; border:1px solid #eee7f0; border-radius:10px; background:#fff; overflow-wrap:anywhere; }
.review-item p { margin:0 0 10px; }.review-author { display:flex; align-items:center; gap:8px; font-weight:700; }
.anonymous-avatar { display:inline-grid; place-items:center; width:32px; height:32px; border-radius:50%; background:#eee8f0; color:#66596f; }
.review-score { color:#624385; font-weight:700; }.review-text { white-space:pre-wrap; }.review-time { color:#66596f; font-size:13px; }
.review-service { display:flex; flex-wrap:wrap; gap:10px 24px; margin:16px 0 0; padding-top:14px; border-top:1px solid #eee7f0; font-size:13px; }
.review-service div { min-width:0; }.review-service dt { color:#66596f; }.review-service dd { margin:4px 0 0; }
.review-images { display:flex; flex-wrap:wrap; gap:8px; margin-top:14px; }.review-images img { width:88px; height:88px; max-width:100%; object-fit:cover; border-radius:6px; }
@media(max-width:480px) { .review-item { padding:16px; } }
</style>
